import { IntlShape } from 'react-intl';
import { HistoricalDataItemGroup } from '../../../services/historicalData';
import { ICounter } from '../../Devices/Counter';
import { CounterMedium } from '../../Devices/CounterMedium';
import { defaultDataSet } from './defaultOptions';
import { addMinutes, startOfMonth } from 'date-fns';
import { y } from '@fullcalendar/core/internal-common';
import { CounterType } from '../../Devices/CounterType';

export function getLabel(counterMedium: CounterMedium, counterType: CounterType, intl: IntlShape): string {
    switch (counterMedium) {
        case CounterMedium.ElectricityMeter:
            if (counterType === CounterType.Producer)
                return intl.formatMessage({ id: "EnergyOverview.ElectricityProduced", defaultMessage: "Electricity prod." });
            if (counterType === CounterType.FeedOut)
                return intl.formatMessage({ id: "EnergyOverview.ElectricityFeedOut", defaultMessage: "Electricity out" });
            else
                return intl.formatMessage({ id: "EnergyOverview.Electricity", defaultMessage: "Electricity" });
        case CounterMedium.HeatMeter:
            return intl.formatMessage({ id: "EnergyOverview.Heat", defaultMessage: "Heat" });
        case CounterMedium.ColdMeter:
            return intl.formatMessage({ id: "EnergyOverview.Cool", defaultMessage: "Cool" });
        case CounterMedium.WaterMeter:
            return intl.formatMessage({ id: "EnergyOverview.Water", defaultMessage: "Water" });
        case CounterMedium.GasMeter:
            return intl.formatMessage({ id: "EnergyOverview.Gas", defaultMessage: "Gas" });
        case CounterMedium.FuelMeter:
            return intl.formatMessage({ id: "EnergyOverview.Fuel", defaultMessage: "Fuel" });
        default:
            return 'UNKNOWN';
    }
}

export function datasetFromData(data: ICounterAndData, color: string, intl: IntlShape) {
    


    return {

        ...defaultDataSet,
        label: getLabel(data.counter.counterMedium,data.counter.counterType, intl),// + " - " + data.counter.description,
        data: data?.data.map((item) => 
        { 
            const timezoneOffset = (new Date(item.timeStamp)).getTimezoneOffset(); // timezones like Bogota -5 aree wrong without the correction
            return { x: startOfMonth(addMinutes(new Date(item.timeStamp), timezoneOffset)), y: item.sumValue } 
        }),
        backgroundColor: color,
    }
}


export const getSum = (value: ICounterAndData) => {
    return value.data ? value.data.reduce((partialSum, item: HistoricalDataItemGroup) => item ? (partialSum + (item?.sumValue)) : partialSum, 0) : 0;
}

export const getSum2 = (value: ICounterAndData[]) => {
    return value?.reduce((partialSum, item: ICounterAndData) => item ? (partialSum + getSum(item)) : partialSum, 0);
}


export interface ICounterAndData {
    counter: ICounter,
    data: HistoricalDataItemGroup[]
}


